module.exports = __webpack_public_path__ + "img/Jennifer&Marcus-11.c81647c5.jpg";